import React, { useContext, useEffect, useState } from 'react';
import { TheMasterContextProvider } from '../../MyContexts/Master_Context';
import Sidenavigation1 from '../../layouts/Sidenavigation1';
import Topnavigation from '../../layouts/Topnavigation';
import RestSet from './Rests/RestSet';

import { MenuContextProvider, RestContextProvider } from '../../MyContexts/Rest_Context';
import { UserContext } from '../../MyContexts/Users_Context';
import RestSetSmall from './Rests/RestSetSmall';

const MyRestSettings = (props) => {
    
    const [user, setUser] = useContext(UserContext)

    const [loading, setLoading] = useState(true);

    useEffect(() => {

    }, []);



    return (
        <div className="ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar">
            {loading ?
                <TheMasterContextProvider>
                    <Sidenavigation1 />
                    <main className="body-content">
                        <RestContextProvider>
                            <MenuContextProvider>
                                <Topnavigation />
                                {(user?.permiss == "admin") ?
                                    <RestSet newRest={props.newRest} />
                                    : ""}
                                    {(user?.permiss == "restAdmin") ?
                                    <RestSetSmall newRest={props.newRest} />
                                    : ""}
                            </MenuContextProvider>
                        </RestContextProvider>
                    </main>
                    {/* <Quickbar /> */}
                </TheMasterContextProvider>
                : ""}
        </div>
    );
}

export default MyRestSettings;